export interface Subscription {
  id?: string;
  subscriptionName: string;
  description: string;
  monthlyPrice: number;
  discountedAnnualRate?: number;
  status: SubscriptionStatus;
  features: SubscriptionFeatures;
}

export enum SubscriptionStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
  DEACTIVATED = 'DEACTIVATED',
}

export interface SubscriptionFeatures {
  aiIntegration: boolean;
  maxQuizRespondents: number;
  maxQuestionsPerQuiz: number;
  questionsOrder: QuestionsOrder;
  testDuration: TestDuration;
  honestRespondentTech: HonestRespondentTech;
  aiAnswerReview: boolean;
}

export interface QuestionsOrder {
  randomOrder: boolean;
  allowSkipping: boolean;
}

export interface TestDuration {
  enabled: boolean;
  durationInMinutes?: number;
}

export interface HonestRespondentTech {
  enabled: boolean;
  blockOnDetection: boolean;
}
